import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { IRecent } from '../types/IRecent';
import { IViewUsageInfo } from '../types/IUsageInfo';
import { IUser } from '../types/IUser';
import { IView } from '../types/IView';
import { IWorkbookParent } from '../types/IWorkbook';
import { INamedItem, ITypedItem } from '../types/resourceParts';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetViewsParams extends IGetItemsParams {
}

export interface IGetViewsResult extends IGetItemsResult {
  views?: IView[];
  workbooks?: IWorkbookParent[];
  projects?: INamedItem[];
  containers?: ITypedItem[];
  users?: IUser[];
  maxStats?: IViewUsageInfo;
  favorites?: string[];
  recents?: IRecent[];
}

export class GetViewsRequest extends Request<IGetViewsParams, IGetViewsResult> {
  constructor(params: IGetViewsParams) {
    super('getViews', params);
  }
}
